export const DOCUMENT_FILE_LOCATION_FOUND =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Documents.DocumentFileLocationFound";

export const COMMAND_EXECUTION_ERROR = "MasterPartner.PublishedLanguage.Events.CommandExecutionError";
export const COMMAND_EXECUTION_WARNING = "PublishedLanguage.Events.CommandExecutionWarning";
export const TASKS_COMMAND_EXECUTION_ERROR = "PublishedLanguage.Events.TasksCommandExecutionError";
export const COMMAND_VALIDATION_ERROR = "MasterPartner.PublishedLanguage.Events.CommandValidationError";

//Settings
export const CACHE_RESET = "Charisma.Leasing.PublishedLanguage.Events.Settings.CacheReset";
export const LANGUAGE_PUBLISHED = "Tasks.PublishedLanguage.Events.LanguagePublished";
export const LFO_VERSIONS_CALCULATED = "Charisma.Leasing.PublishedLanguage.Events.Settings.LfoVersionsCalculated";

export const USER_RIGHTS_CHANGED = "Charisma.Leasing.PublishedLanguage.Events.ErpUser.UserRightsChanged";

//NOTIFICATIONS
export const NOTIFICATION_MARKED_AS_READ = "Notifier.PublishedLanguage.IntegrationEvents.NotificationMarkedAsRead";
export const NOTIFICATION_SENT = "Notifier.PublishedLanguage.IntegrationEvents.NotificationSent";
export const NOTIFICATION_DISMISSED = "Notifier.PublishedLanguage.IntegrationEvents.NotificationDismissed";
export const ALL_NOTIFICATIONS_MARKED_AS_READ =
  "Notifier.PublishedLanguage.IntegrationEvents.AllNotificationsMarkedAsRead";
export const ALL_NOTIFICATIONS_DISMISSED = "Notifier.PublishedLanguage.IntegrationEvents.DismissAllNotifications";
export const IDENTITY_USER_CHANGED = "MasterPartner.Hubs.Models.Events.UserLoggedIn";
